export default __webpack_public_path__ + "static/media/Simone Scalia.c5a8a7b7.jpg";